export default __webpack_public_path__ + "static/media/noImage.f7b87bf2.svg";